/* eslint import/no-cycle: 0 */
import { events } from 'client/GrowthEngineering/util/GrowthConstants';
import EventManager from 'client/GrowthEngineering/EventManager';
import ExperimentsManager from 'client/GrowthEngineering/ExperimentsManager';

/**
 * Trigger Signup events
 */
const triggerAccountCreated = async (payload = {}) => {
  EventManager.triggerEvent(events.accountCreated, payload);
};

const triggerAccountCreateFailed = (payload = {}) => {
  EventManager.triggerEvent(events.accountCreateFailed, payload);
};

const triggerAccountVerified = async (payload = {}) => {
  EventManager.triggerEvent(events.accountVerified, payload);
};

const triggerAdminGoogleRegistrationPageClick = (payload = {}) => {
  EventManager.triggerEvent(events.loginRedirectionPage, payload);
};

const triggerEmailRegexFrontendBackendMismatch = (payload = {}) => {
  EventManager.triggerEvent(events.emailRegexFrontendBackendMismatch, payload);
};

const triggerReferralSourceSignup = (payload = {}) => {
  EventManager.triggerEvent(events.referralSourceSignup, payload);
};

const triggerRequestDemoClicked = (props = {}) => {
  EventManager.triggerEvent(events.requestDemoClicked, props);
};

const triggerResendEmailAfterError = (props = {}) => {
  EventManager.triggerEvent(events.resendVerificationEmailAfterError, props);
};

const triggerResendEmailBeforeError = (props = {}) => {
  EventManager.triggerEvent(events.resendVerificationEmailBeforeError, props);
};

const triggerSignupLoginLinkClicked = () => {
  EventManager.triggerEvent(events.signupLoginLinkClicked);
};

const triggerSignupPageViewed = (payload = {}) => {
  ExperimentsManager.trackExperimentEvent('signup_pageview');
  EventManager.triggerEvent(events.signupPageViewed, payload);
};

const triggerSignupStepBack = (payload = {}) => {
  EventManager.triggerEvent(events.signupStepBack, payload);
};

const triggerSignupStepCompleted = (payload = {}) => {
  EventManager.triggerEvent(events.signupStepCompleted, payload);
};

const triggerSignupWithGoogleClicked = (props = {}) => {
  EventManager.triggerEvent(events.signupWithGoogleClicked, props);
};

const triggerSignupCancelled = (payload = {}) => {
  EventManager.triggerEvent(events.signupCancelled, payload);
};

const triggerSignupSubmitted = async (payload = {}) => {
  EventManager.triggerEvent(events.signupSubmitted, payload);
};

const triggerUseCaseSelected = (payload = {}) => {
  EventManager.triggerEvent(events.useCaseSelected, payload);
};

const triggerSignupUtmData = (payload = {}) => {
  EventManager.triggerEvent(events.signupUtmData, payload);
};

const triggerVerificationHelpExpanded = () => {
  EventManager.triggerEvent(events.verificationHelpExpanded);
};

const triggerSegmentUserIdMapping = (payload = {}) => {
  EventManager.triggerEvent(events.segmentUserIdMapping, {
    ...payload,
    location: 'signup',
  });
};

// Generic Events
const triggerButtonClicked = (payload = {}) => {
  EventManager.triggerEvent(events.buttonClicked, payload);
};

const triggerLinkClicked = (payload = {}) => {
  EventManager.triggerEvent(events.linkClicked, payload);
};

const triggerModalViewed = (payload = {}) => {
  EventManager.triggerEvent(events.modalViewed, payload);
};

export default {
  triggerAccountCreated,
  triggerAccountCreateFailed,
  triggerAccountVerified,
  triggerAdminGoogleRegistrationPageClick,
  triggerButtonClicked,
  triggerEmailRegexFrontendBackendMismatch,
  triggerLinkClicked,
  triggerModalViewed,
  triggerReferralSourceSignup,
  triggerRequestDemoClicked,
  triggerResendEmailAfterError,
  triggerResendEmailBeforeError,
  triggerSegmentUserIdMapping,
  triggerSignupCancelled,
  triggerSignupLoginLinkClicked,
  triggerSignupPageViewed,
  triggerSignupStepBack,
  triggerSignupStepCompleted,
  triggerSignupSubmitted,
  triggerSignupUtmData,
  triggerSignupWithGoogleClicked,
  triggerUseCaseSelected,
  triggerVerificationHelpExpanded,
};
